/** Tipos de Mercados */
export interface ConfigEmpresaTipoMercado {
    id: number;
    nome: string;
}

export const tipoMercadoMarca: ConfigEmpresaTipoMercado = {id: 1, nome: 'Marca'};
export const tipoMercadoUnidadeNegocio: ConfigEmpresaTipoMercado = {id: 2, nome: 'Unidade de Negócio'};

export const tiposMercados: ConfigEmpresaTipoMercado[] = [
    tipoMercadoMarca,
    tipoMercadoUnidadeNegocio
];

/** Verifica se o tipo de mercado é Marca */
export function isTipoMercadoMarca(tipoMercado: number): boolean {
    if (!tipoMercado) {
        return false;
    }
    return tipoMercado === tipoMercadoMarca.id;
}

/** Verifica se o tipo de mercado é Unidade de Negócio */
export function isTipoMercadoUnidadeNegocio(tipoMercado: number): boolean {
    if (!tipoMercado) {
        return false;
    }
    return tipoMercado === tipoMercadoUnidadeNegocio.id;
}

/** Verifica se o tipo de mercado é Unidade de Negócio e com Linha de Produção */
export function isTipoMercadoUnidadeNegocioComLinhaProducao(tipoMercado: number, tipoMercadoUnidadeNegocioComLinhaProducao: boolean): boolean {
    // Se nem for o tipo de mercado unidade de negócio, então retorna sempre false
    if (!isTipoMercadoUnidadeNegocio(tipoMercado)) {
        return false;
    }

    return tipoMercadoUnidadeNegocioComLinhaProducao === true;
}
